import gql from 'graphql-tag';

export const DiscountTemplateDetails = gql`
  fragment DiscountTemplateDetails on DiscountTemplate {
    id
    name
    type
    discount_value
    min_checkout_amount {
      value
      currency
    }
    start_date_offset {
      offset
      offset_type
    }
    end_date_offset {
      offset
      offset_type
    }
    start_date
    end_date
    products
  }
`;
